import { Button } from '@/components/ui/button';
import { PDKLenderIcon, PDKNoIcon } from '@/components/ui/pdk-icons';
import { cn } from '@/lib/utils';
import type { Lender } from '@/models/types';
import useLenderOptions from './use-lender-options';

const DealLenderBadge = ({
  lender,
  hideCopy,
  hideIcon,
  className,
}: {
  lender: Lender | null | undefined;
  hideCopy?: boolean;
  hideIcon?: boolean;
  className?: string;
}) => {
  const { lenderOptions } = useLenderOptions();

  const currentlySelectedLender = lenderOptions.find(
    (option) => option.id === lender?.id,
  );

  return (
    <Button variant="ghost" className={cn('p-1 h-fit', className)}>
      {!currentlySelectedLender && (
        <>
          <PDKNoIcon className="h-3.5 w-3.5" />
          {!hideCopy && (
            <p className="rounded text-xs  text-gray-600">No Lender</p>
          )}
        </>
      )}
      {currentlySelectedLender && (
        <div className="flex flex-row gap-2 items-center">
          {!hideIcon && (
            <PDKLenderIcon
              className={cn('h-3.5 w-3.5 cursor-pointer text-gray-500', {})}
            />
          )}
          {!hideCopy && (
            <div className="text-xs  text-gray-500 text-nowrap">
              {currentlySelectedLender.label}
            </div>
          )}
        </div>
      )}
    </Button>
  );
};

export default DealLenderBadge;
